import _asyncToGenerator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _asyncIterator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncIterator.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import "./chunk-PXG64RU4.js"; // src/streamedQuery.ts

import { addToEnd } from "./utils.js";

function streamedQuery(_ref) {
  var queryFn = _ref.queryFn,
      _ref$refetchMode = _ref.refetchMode,
      refetchMode = _ref$refetchMode === void 0 ? "reset" : _ref$refetchMode,
      maxChunks = _ref.maxChunks;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var query, isRefetch, result, stream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;

      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            query = context.client.getQueryCache().find({
              queryKey: context.queryKey,
              exact: true
            });
            isRefetch = !!query && query.state.data !== void 0;

            if (isRefetch && refetchMode === "reset") {
              query.setState({
                status: "pending",
                data: void 0,
                error: null,
                fetchStatus: "fetching"
              });
            }

            result = [];
            _context2.next = 6;
            return queryFn(context);

          case 6:
            stream = _context2.sent;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 9;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var chunk;
              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    chunk = _step.value;

                    if (!context.signal.aborted) {
                      _context.next = 3;
                      break;
                    }

                    return _context.abrupt("return", 1);

                  case 3:
                    if (!isRefetch || refetchMode !== "replace") {
                      context.client.setQueryData(context.queryKey, function () {
                        var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        return addToEnd(prev, chunk, maxChunks);
                      });
                    }

                    result = addToEnd(result, chunk, maxChunks);

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _loop);
            });
            _iterator = _asyncIterator(stream);

          case 12:
            _context2.next = 14;
            return _iterator.next();

          case 14:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 21;
              break;
            }

            return _context2.delegateYield(_loop(), "t0", 16);

          case 16:
            if (!_context2.t0) {
              _context2.next = 18;
              break;
            }

            return _context2.abrupt("break", 21);

          case 18:
            _iteratorAbruptCompletion = false;
            _context2.next = 12;
            break;

          case 21:
            _context2.next = 27;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t1 = _context2["catch"](9);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 27:
            _context2.prev = 27;
            _context2.prev = 28;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 32;
              break;
            }

            _context2.next = 32;
            return _iterator.return();

          case 32:
            _context2.prev = 32;

            if (!_didIteratorError) {
              _context2.next = 35;
              break;
            }

            throw _iteratorError;

          case 35:
            return _context2.finish(32);

          case 36:
            return _context2.finish(27);

          case 37:
            if (isRefetch && refetchMode === "replace" && !context.signal.aborted) {
              context.client.setQueryData(context.queryKey, result);
            }

            return _context2.abrupt("return", context.client.getQueryData(context.queryKey));

          case 39:
          case "end":
            return _context2.stop();
        }
      }, _callee, null, [[9, 23, 27, 37], [28,, 32, 36]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}

export { streamedQuery };